import Link from 'next/link';

import { theme } from 'constants/theme';

import { useDarkMode } from 'hooks/browser/mediaQueries';
import { useGetQueryFilters } from 'hooks/filters';

import { CloseIcon } from 'components/icons/CloseIcon';

export const TopicFilters = () => {
  const { filtersState } = useGetQueryFilters();
  const { isDarkMode } = useDarkMode();
  const { topicFilters, url } = filtersState;

  if (topicFilters.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full max-w-[1400px] justify-start space-x-2 px-3 pt-5 sm:px-6">
      {topicFilters.map(topic => {
        const filteredTopics = topicFilters.filter(t => t !== topic);

        url.searchParams.delete('topicFilter');
        filteredTopics.forEach(t => url.searchParams.append('topicFilter', t));

        return (
          <Link href={`${url.pathname}${url.search}`} key={topic}>
            <span className="flex items-center rounded-full bg-black/10 py-[6px] pl-4 pr-[6px] text-mineShaftGrey dark:bg-white/10 dark:text-white">
              <span className="text-xs font-medium">{topic}</span>

              <span className="ml-2">
                <CloseIcon
                  size={18}
                  color={theme.colors.white}
                  backgroundColor={
                    isDarkMode ? theme.colors.silverGrey : theme.colors.black
                  }
                />
              </span>
            </span>
          </Link>
        );
      })}
    </div>
  );
};